import { render, staticRenderFns } from "./triggerlist.vue?vue&type=template&id=5ca81c5c&scoped=true&"
import script from "./triggerlist.vue?vue&type=script&lang=js&"
export * from "./triggerlist.vue?vue&type=script&lang=js&"
import style0 from "./triggerlist.vue?vue&type=style&index=0&id=5ca81c5c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca81c5c",
  null
  
)

export default component.exports